import type { ShipmentStatus } from "./types";

const rands = new Intl.NumberFormat("en-ZA", {
  style: "currency",
  currency: "ZAR",
  minimumFractionDigits: 2,
});

export function money(cents: number | undefined | null) {
  return rands.format((cents ?? 0) / 100);
}

export function date(value?: string | null) {
  if (!value) return "-";
  return new Date(value).toLocaleDateString("en-ZA", { day: "numeric", month: "short", year: "numeric" });
}

export function dateTime(value?: string | null) {
  if (!value) return "-";
  return new Date(value).toLocaleString("en-ZA", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function kg(grams: number) {
  return `${(grams / 1000).toFixed(2)} kg`;
}

export const statusLabels: Record<ShipmentStatus, string> = {
  draft: "Draft",
  booked: "Booked",
  awaiting_collection: "Awaiting collection",
  collected: "Collected",
  in_transit: "In transit",
  at_hub: "At hub",
  out_for_delivery: "Out for delivery",
  delivered: "Delivered",
  attempt_failed: "Delivery attempt failed",
  collection_failed: "Collection failed",
  exception: "Exception",
  cancelled: "Cancelled",
  returned: "Returned to sender",
};

export type Tone = "neutral" | "progress" | "good" | "warn" | "bad" | "attention";

export const statusTone: Record<ShipmentStatus, Tone> = {
  draft: "neutral",
  booked: "progress",
  awaiting_collection: "progress",
  collected: "progress",
  in_transit: "progress",
  at_hub: "progress",
  out_for_delivery: "progress",
  delivered: "good",
  attempt_failed: "warn",
  collection_failed: "warn",
  exception: "bad",
  cancelled: "neutral",
  returned: "bad",
};

export function transitCopy(days: number) {
  if (days <= 0) return "Same day";
  if (days === 1) return "Next day";
  return `${days} business days`;
}

export function initials(first?: string, last?: string) {
  return `${first?.[0] ?? ""}${last?.[0] ?? ""}`.toUpperCase() || "WS";
}

// Service codes are stored on the shipment; these are what a customer sees.
export const serviceLabels: Record<string, string> = {
  SDX: "Same Day",
  ONX: "Overnight Express",
  ECO: "Economy",
  STD: "Standard",
};

export const PROVINCES = [
  "Eastern Cape",
  "Free State",
  "Gauteng",
  "KwaZulu-Natal",
  "Limpopo",
  "Mpumalanga",
  "Northern Cape",
  "North West",
  "Western Cape",
];
